import { memo } from 'react';

import { TableCell, TableCellProps } from '@mui/material';

interface DataCellProps extends TableCellProps {
  data: string | number;
}

const DataCell = ({ data, ...cellProps }: DataCellProps) => (
  <TableCell {...cellProps}>{data}</TableCell>
);

export default memo(DataCell);
